export const projectsColor = '#00ccff';

export const projectsHeading = 'Projects';

export const projectsDescription =
  "Here are some of the latest projects I've worked on. For more information on a specific project, click on its icon. For a complete list of github projects, check out my ";

export const projectsGithubLink = 'https://github.com/QuintonTracey';

export const projectsItems = [
  {
    title: 'BattleBees Multiplayer',
    iconKey: 'battlebees',
    link: 'https://github.com/QuintonTracey/BattleBees',
    descriptions: [
      'A multiplayer word game inspired by spelling bee puzzles, built with React, TypeScript, and Socket.IO.',
    ],
  },
  {
    title: 'PIE — Portfolio Intelligence Engine',
    iconKey: 'pie',
    link: 'https://github.com/QuintonTracey/Portfolio-Intelligence-Engine',
    descriptions: [
      'A portfolio tracker that writes a daily AI research briefing on the stocks you own — every claim backed by independently deduplicated and reachability-checked sources. Built with React, TypeScript, FastAPI, and Firebase. Live demo at portfolio-intelligence-eng.web.app.',
    ],
  },
  {
    title: 'EndpointExplorer',
    iconKey: 'endpointexplorer',
    link: 'https://github.com/QuintonTracey/EndpointExplorer',
    descriptions: [
      'My group capstone project which aimed to streamline the reverse engineering process by transforming natural user interactions with a website into key insights about the API of the target web application.',
    ],
  },
  {
    title: 'Elevator System',
    iconKey: 'elevator',
    link: 'https://github.com/QuintonTracey/Elevator_System',
    descriptions: ['An elevator control system and simulator.'],
  },
  {
    title: 'Monopoly',
    iconKey: 'monopoly',
    link: 'https://github.com/QuintonTracey/Monopoly',
    descriptions: ['A multiplayer monopoly game to be played with multiple people or with bots on one computer.'],
  },
  {
    title: 'Soccer Database',
    iconKey: 'soccer',
    link: 'https://github.com/QuintonTracey/COMP3005Project',
    descriptions: ['Designed a database to store soccer events from a dataset that spans multiple competitions and seasons'],
  },
];
